import React from 'react';
import { formatVersionSelectorLabel, formatVersionOptionDate } from '../../utils/versionDisplayName';

export interface VersionSelectOptionLabelClasses {
  row: string;
  name: string;
  date: string;
}

const VersionSelectOptionLabel: React.FC<{
  version: any;
  classes: VersionSelectOptionLabelClasses;
}> = ({ version, classes }) => {
  const dateStr = formatVersionOptionDate(version);
  return (
    <div className={classes.row}>
      <span className={classes.name}>{formatVersionSelectorLabel(version.name)}</span>
      {dateStr ? <span className={classes.date}>{dateStr}</span> : null}
    </div>
  );
};

export default VersionSelectOptionLabel;
